import compact from 'lodash/compact'

const ADDRESS_PROPERTIES = [
  '_address_1',
  '_address_2',
  '_suburb',
  '_city',
  '_state',
  '_postcode',
  '_country_id',
]

export default function CustomerAddressFilter() {
  function getAddress(customer, addressType) {
    const addressDetails = ADDRESS_PROPERTIES.map(prop => {
      const value = customer[addressType + prop]
      return value && value.trim()
    })

    return compact(addressDetails).join(', ')
  }

  /**
   * Get the address details for the given customer, combining all address fields for the provided address type. If an
   * address type has not been provided the customer's physical address will be returned, otherwise it will fall back to
   * the customer's postal address.
   *
   * @function
   *
   * @param  {Customer} customer
   *         The customer to get the name of
   *
   * @param  {String} [addressType]
   *         The address field type, either 'physical' or 'postal'
   *
   * @return {String} The combined address
   */
  return function (customer, addressType) {
    if (!customer) {
      return
    }

    if (!addressType) {
      return getAddress(customer, 'physical') || getAddress(customer, 'postal')
    } else {
      return getAddress(customer, addressType)
    }
  }
}
